<template>
  <div class="main__wrapper">
    <div class="container-xxxl container-xxl container-xl container">
      <div class="col-xxl-4 col-xl-4 col-lg-6 col-md-8 offset-xxl-4 offset-xl-4 offset-lg-3 offset-md-2">
        <div class="sign__block">
          <router-link
              :to="{ name: 'Home' }"
              class="sign__logo"
          ><img src="@/assets/v2/img/logo_ru.svg" alt="Logo"></router-link>
          <div class="sign__form">
            <router-link
                :to="{ name: 'Login' }"
                class="button__back"
            ><svg class="button__icon icon" viewBox="0 0 24 24" width="24" height="24">
              <use xlink:href="@/assets/v2/img/sprite.svg#chevron__right"></use>
            </svg>{{ $lang.app.BACK }}</router-link>
            <h3><strong>{{ $lang.app.RESTORING_THE_PROFILE }}</strong></h3>
            <div
                v-if="isSent"
                class="text-center py-4">
              <div class="flex justify-center items-center text-green-600 mb-2">
                <CheckCircleIcon class="flex-shrink-0 w-8 h-8 mr-2"/>
                <p class="text-xl">{{ $lang.app.EMAIL_SENT }}!</p>
              </div>
              <p class="text-gray-600">
                {{ $lang.app.CHECK_EMAIL_FOR_PASSWORD_RESET }}.
              </p>
            </div>
            <Form v-else
                  @submit="submit"
                  :validation-schema="schema">
              <div class="input__group">
                <label for="sign__email" class="label">{{ $lang.app.EMAIL }}</label>
                <Field
                    name="email"
                    v-slot="{ field, errorMessage }"
                >
                  <input v-bind="field"
                         type="email"
                         id="sign__email"
                         class="input"
                         :class="{'input--fail': errorMessage }"
                         :placeholder="$lang.app.ENTER_EMAIL"
                         required>
                  <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
                </Field>
              </div>
              <button class="button button--full">{{ $lang.app.RESTORE }}</button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {Field, Form} from "vee-validate";
import * as yup from "yup";
import authApi from "../api/auth";

export default {
  name: "ForgotPassword",
  components: {
    Field,
    Form,
  },
  data() {
    return {
      submitting: false,
      isSent: false,

      schema: yup.object({
        email: yup.string().required(),
      }),
    };
  },
  methods: {
    submit(values, actions) {
      this.submitting = true
      authApi.sendLinkToEmail(values)
          .then(() => {
            this.isSent = true
          })
          .catch((error) => {
            if (error.response.status === 422) {
              actions.setErrors(error.response.data.errors);
            }
            if (error.response.status === 429) {
              actions.setErrors({'email': error.response.data.message})
            }
          }).finally(() => {
            this.submitting = false
      })
    },
  },
};
</script>
